export const UI_HOME_CONST = {
  EVENTS: {
    TABS: {
      CLINICS: 'clinic',
      ONLINE: 'online',
      OTHER: 'other',
    },
  },
}
